'use es6';

import { RECEIVED_VIDEO_MAP, REQUESTED_VIDEO_MAP_FAILED, REQUESTED_VIDEO_MAP } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
import VideoMap from '../models/VideoMap';
export default ((state = new VideoMap(), action) => {
  switch (action.type) {
    case REQUESTED_VIDEO_MAP:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_VIDEO_MAP:
      return action.payload.videoMap;
    case REQUESTED_VIDEO_MAP_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});